import { useTranslation } from 'react-i18next'
import { FaTrashAlt } from 'react-icons/fa'
import { useState } from 'react'

import { Add, FlagCircle } from '@mui/icons-material'
import { Box, Button, Chip, Fab, Grid, Tooltip, Typography } from '@mui/material'
import { cloneDeep } from 'lodash'

import { useField, useFormikContext } from 'formik'

import CheckboxField from 'components/atoms/fields/CheckboxField'
import InputField from 'components/atoms/fields/InputField'
import SelectField from 'components/atoms/fields/SelectField'

import { ELEMENT_RADIUS_MID, GREY_BORDER, PRIMARY_RED } from 'utils/customizedTheme'
import { weightSelectData } from 'utils/helpers'

import { IGradeItem } from 'types'
import DialogPopup from './DialogPopup'
import GoalbankPage from 'pages/protected/GoalbankPage'
import RichTextField from 'components/atoms/fields/RichTextField'

const GradeItemList = ({ fieldProps, disabled }) => {
  const { t } = useTranslation()
  const [field] = useField<IGradeItem[]>(fieldProps.name)
  const { setFieldValue } = useFormikContext() // Manually set field value in Formik state

  const handleAddEntity = () => {
    setFieldValue(fieldProps.name, [
      ...field.value,
      {
        title: '',
        description: '',
        importance: {id: '5', title: '5'},
        counts_to_final_grade: true,
        is_shown_to_students: true,
      },
    ])
  }

  const handleRemoveEntity = (index: number) => {
    // Clone the original array
    const entities = cloneDeep(field.value)

    // Entity from array
    entities.splice(index, 1)

    setFieldValue(fieldProps.name, entities)
  }

  return (
    <>

      {field?.value?.length > 0 ? (
        field.value.map((value: IGradeItem, index: number) => (
          <Grid
            container
            spacing={2}
            key={index}
            sx={{
              borderRadius: ELEMENT_RADIUS_MID,
              marginTop: '40px'
            }}
          >
            <Grid item xs={8} lg={10}>
              <InputField
                valueSelector='title'
                fieldProps={{
                  label: t('common.title'),
                  name: `${fieldProps.name}[${index}]`,
                  required: true,
                }}
                disabled={disabled}
              />
            </Grid>
            <Grid item xs={4} lg={2}>
              <SelectField
                valueSelector='importance'
                fieldProps={{
                  label: t('common.weight'),
                  name: `${fieldProps.name}[${index}]`,
                  required: true,
                }}
                apiCall={weightSelectData}
                disabled={disabled}
              />
            </Grid>
            <Grid item xs={12}>
              <RichTextField
                  fieldProps={{
                    label: t('common.description'),
                    name: `${fieldProps.name}[${index}]`,
                  }}
                  valueSelector='description'
                  label={t('common.description')}
                  disabled={disabled}
                />
            </Grid>

           
            <Grid item xs={12} sx={{ display: 'flex' }}>

               {/*
              <Box className="transparent-background" sx={{ marginRight: '1rem' }}>
                <CheckboxField
                  valueSelector='is_shown_to_students'
                  index={index}
                  fieldProps={{
                    label: t('assignments.release-scores'),
                    name: `${fieldProps.name}[${index}]`,
                  }}
                  disabled={disabled}
                />
              </Box>
              <CheckboxField
                valueSelector='counts_to_final_grade'
                index={index}
                fieldProps={{
                  label: t('assignments.counts-in-final-grade'),
                  name: `${fieldProps.name}[${index}]`,
                }}
                disabled={disabled}
              />
              */}

              {!disabled &&
              <Box ml={'auto'} sx={{ display: 'flex', alignItems: 'center' }} className="transparent-background" >
                <Tooltip title={`${t('common.delete')}`} arrow placement='top'>
                  <Button
                    onClick={() => handleRemoveEntity(index)}
                    aria-label='delete'
                    size='small'
                    disabled={disabled}
                    color='error'
                    variant='outlined'
                    sx={{ margin: '0', boxShadow: 'none', padding: '0.5rem 0.1rem', minWidth: '2.5rem !important', maxWidth: '2.5rem !important'  }}
                  >
                    <FaTrashAlt style={{ fontSize: '1.2rem' }} />
                  </Button>
                </Tooltip>
              </Box>
              }
            </Grid>
          </Grid>
        ))
      ) : <></>}

      {!disabled &&   
      <Box sx={{ marginTop: '20px' }}>

        <Tooltip title={`${t('common.add')}`} arrow placement='top'>
          <Fab
            aria-label='add'
            size='small'
            disabled={disabled}
            onClick={handleAddEntity}
            color='success'
            sx={{ boxShadow: 'none', width: 'auto', padding: '0px 10px', fontWeight: 'bold', textTransform: 'uppercase' }}
          >
            <Add style={{ fontSize: '1.8rem' }} />  {t('common.add-new-objective')}
          </Fab>
        </Tooltip>

      </Box>   
      }     
    </>
  )
}

export default GradeItemList
